import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const previewClipchampVideoModalStyles = makeStyles({
  dialog: {
    minWidth: '830px',
    minHeight: '350px',
  },
  dialogContentContainer: {
    display: 'flex',
    flexDirection: 'row',
    ...shorthands.gap(tokens.spacingHorizontalXXXL),
  },
  detailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalL),
  },
  textGroup: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingHorizontalS),
  },
  errorMsg: {
    color: tokens.colorStatusDangerForeground1,
  },
  dialogContent: {
    overflowX: 'hidden',
    overflowY: 'hidden',
  },
});
